import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12e2a871"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "header",
  ref: "header"
}
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/" }, " 首    页", -1))
const _hoisted_5 = ["href", "onMouseover", "onMouseleave"]
const _hoisted_6 = ["href"]
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_MenuOutlined = _resolveComponent("MenuOutlined")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_row, { style: {"width":"70%","margin":"0 auto","display":"flex","justify-content":"space-between"} }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            span: 6,
            xxl: 6,
            xl: 6,
            lg: 6,
            xs: 12
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("img", {
                  src: _ctx.logoUrl,
                  alt: ""
                }, null, 8, _hoisted_3)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, {
            span: 12,
            xxl: 12,
            xl: 12,
            lg: 12,
            xs: 3
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_menu, {
                selectedKeys: _ctx.navIndex,
                "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.navIndex) = $event)),
                mode: "horizontal",
                theme: "dark"
              }, {
                overflowedIndicator: _withCtx(() => [
                  _createVNode(_component_MenuOutlined)
                ]),
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_component_a_menu_item, { key: 0 }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  })),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navList, (item, index) => {
                    return (_openBlock(), _createBlock(_component_a_menu_item, {
                      key: index + 1
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          href: '/list/' + item.categoryCode,
                          onMouseover: ($event: any) => (_ctx.mouseOver(index)),
                          onMouseleave: ($event: any) => (_ctx.mouseLeave(index))
                        }, _toDisplayString(item.categoryName), 41, _hoisted_5)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["selectedKeys"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ], 512),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          ref: "subMenuRef",
          class: _normalizeClass(["pover", { expanded: _ctx.subMenuShow }]),
          onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_ctx.mouseOver(_ctx.navIndex[0] - 1))),
          onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.mouseLeave(_ctx.navIndex[0] - 1)))
        }, [
          _createVNode(_component_a_row, { class: "content" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { class: "left_menu col-md-3" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_menu, {
                    selectedKeys: _ctx.currentSub,
                    "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentSub) = $event)),
                    theme: "dark"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leftMenu, (item, index) => {
                        return (_openBlock(), _createBlock(_component_a_menu_item, {
                          key: index,
                          onMouseover: ($event: any) => (_ctx.mouseSubOver(index))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_sub_menu, { theme: "dark" }, {
                              title: _withCtx(() => [
                                _createElementVNode("a", {
                                  href: '/list/' + item.parentCode
                                }, _toDisplayString(item.categoryName), 9, _hoisted_6)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onMouseover"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["selectedKeys"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { class: "right_menu col-md-9" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rightMenu, (ele, idx) => {
                        return (_openBlock(), _createBlock(_component_a_col, {
                          span: 6,
                          key: idx
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              onClick: ($event: any) => (_ctx.toArticle(ele.id))
                            }, _toDisplayString(ele.title), 9, _hoisted_7)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ], 34), [
          [_vShow, _ctx.subMenuShow]
        ])
      ]),
      _: 1
    })
  ], 64))
}